/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  ETransportFreightPlutoDto,
  GetFreightsParams
} from '../../model';





/**
 * @summary Insert a freight
 */
export const addFreight = (
    eTransportFreightPlutoDto: ETransportFreightPlutoDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/etransport/freight`,
      eTransportFreightPlutoDto,options
    );
  }



export const getAddFreightMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext> => {

const mutationKey = ['addFreight'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFreight>>, {data: ETransportFreightPlutoDto}> = (props) => {
          const {data} = props ?? {};

          return  addFreight(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddFreightMutationResult = NonNullable<Awaited<ReturnType<typeof addFreight>>>
    export type AddFreightMutationBody = ETransportFreightPlutoDto
    export type AddFreightMutationError = AxiosError<unknown>

    /**
 * @summary Insert a freight
 */
export const useAddFreight = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addFreight>>,
        TError,
        {data: ETransportFreightPlutoDto},
        TContext
      > => {

      const mutationOptions = getAddFreightMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Mark a freight as deleted
 */
export const markFreightDeleted = (
    eTransportFreightPlutoDto: ETransportFreightPlutoDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/v1.1/etransport/freight`,{data:
      eTransportFreightPlutoDto, ...options}
    );
  }



export const getMarkFreightDeletedMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markFreightDeleted>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof markFreightDeleted>>, TError,{data: ETransportFreightPlutoDto}, TContext> => {

const mutationKey = ['markFreightDeleted'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markFreightDeleted>>, {data: ETransportFreightPlutoDto}> = (props) => {
          const {data} = props ?? {};

          return  markFreightDeleted(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkFreightDeletedMutationResult = NonNullable<Awaited<ReturnType<typeof markFreightDeleted>>>
    export type MarkFreightDeletedMutationBody = ETransportFreightPlutoDto
    export type MarkFreightDeletedMutationError = AxiosError<unknown>

    /**
 * @summary Mark a freight as deleted
 */
export const useMarkFreightDeleted = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markFreightDeleted>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markFreightDeleted>>,
        TError,
        {data: ETransportFreightPlutoDto},
        TContext
      > => {

      const mutationOptions = getMarkFreightDeletedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a freight
 */
export const updateFreight = (
    eTransportFreightPlutoDto: ETransportFreightPlutoDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.patch(
      `/api/v1.1/etransport/freight`,
      eTransportFreightPlutoDto,options
    );
  }



export const getUpdateFreightMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext> => {

const mutationKey = ['updateFreight'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFreight>>, {data: ETransportFreightPlutoDto}> = (props) => {
          const {data} = props ?? {};

          return  updateFreight(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFreightMutationResult = NonNullable<Awaited<ReturnType<typeof updateFreight>>>
    export type UpdateFreightMutationBody = ETransportFreightPlutoDto
    export type UpdateFreightMutationError = AxiosError<unknown>

    /**
 * @summary Update a freight
 */
export const useUpdateFreight = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFreight>>, TError,{data: ETransportFreightPlutoDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFreight>>,
        TError,
        {data: ETransportFreightPlutoDto},
        TContext
      > => {

      const mutationOptions = getUpdateFreightMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all E-Transport freight in JSON
 */
export const getFreights = (
    params?: GetFreightsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ETransportFreightPlutoDto[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/etransport/freights`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetFreightsQueryKey = (params?: GetFreightsParams,) => {
    return [
    `/api/v1.1/etransport/freights`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFreightsQueryOptions = <TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(params?: GetFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFreightsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreights>>> = ({ signal }) => getFreights(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFreightsQueryResult = NonNullable<Awaited<ReturnType<typeof getFreights>>>
export type GetFreightsQueryError = AxiosError<unknown>


export function useGetFreights<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params: undefined |  GetFreightsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreights>>,
          TError,
          Awaited<ReturnType<typeof getFreights>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreights<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFreights>>,
          TError,
          Awaited<ReturnType<typeof getFreights>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreights<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all E-Transport freight in JSON
 */

export function useGetFreights<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFreightsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFreightsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(params?: GetFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFreightsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFreights>>> = ({ signal }) => getFreights(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFreightsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFreights>>>
export type GetFreightsSuspenseQueryError = AxiosError<unknown>


export function useGetFreightsSuspense<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params: undefined |  GetFreightsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreightsSuspense<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFreightsSuspense<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all E-Transport freight in JSON
 */

export function useGetFreightsSuspense<TData = Awaited<ReturnType<typeof getFreights>>, TError = AxiosError<unknown>>(
 params?: GetFreightsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFreights>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFreightsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




